import React from 'react'

import { Body2 } from '@ui/Typography'

import { LuckyDrawRewardTypeResponse, Sector } from '@model/LuckyDrawDto'

import styles from '../LuckyDraw.modal.module.scss'

interface PrizesTabProps {
  sectors: Sector[]
  rewardTypes: Record<number, LuckyDrawRewardTypeResponse>
}

export const PrizesTab: React.FC<PrizesTabProps> = ({ sectors, rewardTypes }) => {
  const formatPrizeText = (sector: Sector) => {
    if (sector.currency) {
      return `${sector.reward} ${sector.currency.id}`
    }

    if (sector.rewardType) {
      const rewardTypeId = sector.rewardType.id
      const rewardTypeInfo = rewardTypes[rewardTypeId]
      const localizedTypeName = rewardTypeInfo?.name || sector.rewardType.name
      const rewardValue = Number(sector.reward)
      const typeName =
        rewardValue === 1 ? rewardTypeInfo?.singularName || localizedTypeName : localizedTypeName
      return `${sector.reward !== 0 ? sector.reward : ''} ${typeName}`
    }

    return sector.reward
  }

  if (!sectors.length) return null

  return (
    <div className={styles.tabWrapper}>
      <ul className={styles.prizesList} aria-label='Lucky Draw prizes'>
        {sectors.map((sector) => (
          <li key={sector.id} className={styles.prizeItem}>
            <div className={styles.prizeNumber}>{sector.number}</div>
            <Body2 className={styles.prizeText}>{formatPrizeText(sector)}</Body2>
          </li>
        ))}
      </ul>
    </div>
  )
}
